import { PERIOD_TIME_UNIT_ENUM } from '../../../../../../../enums/PeriodTimeUnitEnum';
import {EmailFrequency} from '../../../../../../../enums/EmailFrecuency';

export const SHIFT_MODEL_DATA = {
    id: '',
    departmentId: '',
    endShiftAt: '',
    range: '',
    startShiftAt: '',
    setData(item) {
        return {
            ...this,
            ...item
        }
    }
}

const getReviewFrequency = (item) => {
    if (item.daily) return EmailFrequency.DAILY.value;
    if (item.weekly) return EmailFrequency.WEEKLY.value;
    if (item.monthly) return EmailFrequency.MONTHLY.value;
    if (item.biweekly) return EmailFrequency.BIWEEKLY.value;
    return EmailFrequency.DAILY.value;
};

export const EMAIL_VALUE_VALIDATE = {
    start: {
        min: 1,
        max: 15
    },
    end: {
        min: 16,
        max: 31
    }
}

export const EMAIL_MODEL_DATA = {
    id:null,
    reviewFrequency: '',
    scheduleTime:'',
    daysAfterSendEmail: '', //daily
    dayOfWeek: '', // weekly
    dayOfMonth: '', // monthly
    startDate: '', // Biweekly
    endDate: '', // Biweekly
    timeZone: '',
    email: '',
    imapHost: '',
    port: '',
    setData(item) {
        const frequency = getReviewFrequency(item);
        const sendDay = String(item?.sendDay ?? '');
        return {
            ...this,
            id: item.id,
            scheduleTime: item?.time,
            reviewFrequency: frequency,

            daysAfterSendEmail: item?.daily ? sendDay : '',
            dayOfWeek: item?.weekly ? sendDay : '',
            dayOfMonth: item?.monthly ? sendDay : '',

            startDate: item?.biweekly ? String(item.firstDay) : '',
            endDate: item?.biweekly ? String(item.secondDay) : '',
            timeZone: item.userTimeZone,
            email: item.email,
            imapHost: item.imapHost,
            port: item.port,
        };
    },
    toRegister() {

        const isDaily = this.reviewFrequency === EmailFrequency.DAILY.value;
        const isWeekly = this.reviewFrequency === EmailFrequency.WEEKLY.value;
        const isBiweekly = this.reviewFrequency === EmailFrequency.BIWEEKLY.value;
        const isMonthly = this.reviewFrequency === EmailFrequency.MONTHLY.value;

        const toNum = (v) => (v === "" || v == null ? 0 : Number(v));

        const sendDay = isDaily
            ? toNum(this.daysAfterSendEmail)
            : isWeekly
                ? toNum(this.dayOfWeek)
                : isMonthly
                    ? toNum(this.dayOfMonth)
                    : 0;
        return {
            id: this.id,
            time: this.scheduleTime,

            daily: isDaily,
            weekly: isWeekly,
            biweekly: isBiweekly,
            monthly: isMonthly,

            firstDay: isBiweekly ? toNum(this.startDate) : 0,
            secondDay: isBiweekly ? toNum(this.endDate) : 0,

            sendDay: sendDay,

            timeZone: this.timeZone,
            email: this.email,
            imapHost: this.imapHost,
            port: this.port
        }
    }
}


export const ATTENDANCE_CYCLE = {
    id:null,
    checkOutCooldown:null,
    frequencyValue:null,
    frequencyTimeUnit:null,
    deferredPeriodValue:null,
    supervisorReviewPeriodFrom:null,
    supervisorReviewPeriodTo:null,
    adminApprovalPeriodFrom:null,
    adminApprovalPeriodTo:null,

    frequencyStart: null,
    frequencyEnd: null,
    frequencyTime: null,
    supervisorStart: null,
    supervisorEnd: null,
    adminStart: null,
    adminEnd: null,

    isValidSupervisorReviewPeriodFrom: true,
    isValidAdminApprovalPeriodFrom: true,
    isValidFrequencyValue: true,
    isValidCheckOutCooldown: true,
    setData: function (item){
        return {
            ...this,
            ...item
        }
    },
    toRegister() {
        const { setData, toRegister, ...data } = this;
        return data;
    },
    isValid () {
        return Number(this.supervisorReviewPeriodFrom) >= 1 &&
            Number(this.adminApprovalPeriodFrom) >= 1 &&
            Number(this.frequencyValue) >= 1 &&
            Number(this.checkOutCooldown) >= 1
    }
}


export const PERIOD_TIME_UNIT_CYCLE = [
    {...PERIOD_TIME_UNIT_ENUM.WEEKS},
    {...PERIOD_TIME_UNIT_ENUM.MONTHS},
    {...PERIOD_TIME_UNIT_ENUM.YEARS}
]
